import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  connect (): void {
    this.filterOutPageParamsFromLocation = this.filterOutPageParamsFromLocation.bind(this)
  }

  change ({ target }: { target: HTMLSelectElement }): void {
    const form = this.element as HTMLFormElement
    const turboFrameId = form.dataset.turboFrame

    if (turboFrameId != null) {
      const frame = this.element.closest(`turbo-frame#${turboFrameId}`) as HTMLElement & { src?: string }

      if (frame != null) {
        frame.src = this.update_url(frame.src ?? form.action, target.value)
        document.addEventListener('turbo:frame-load', this.filterOutPageParamsFromLocation)
        return
      }
    }

    Turbo.visit(this.update_url(form.action, target.value))
  }

  private update_url (original: string, value: string): string {
    const url = new URL(original)

    url.searchParams.set('per_page', value)
    if (url.searchParams.has('page')) url.searchParams.delete('page')

    return url.toString()
  }

  private filterOutPageParamsFromLocation (): void {
    document.removeEventListener('turbo:frame-load', this.filterOutPageParamsFromLocation)

    const url = new URL(location.href)

    if (!url.searchParams.has('page') && !url.searchParams.has('per_page')) return

    if (url.searchParams.has('page')) url.searchParams.delete('page')
    if (url.searchParams.has('per_page')) url.searchParams.delete('per_page')

    Turbo.navigator.history.replace(url)
  }
}
